module.exports = __webpack_public_path__ + "static/ulastirma-sag-ab4f67d1b02357c3c3c6d5432cee275b.png";